// extracted by mini-css-extract-plugin
module.exports = {"selector-indice-container":"SelectorIndice_selector-indice-container__2_T-l","selector-indice":"SelectorIndice_selector-indice__3Fc-h","active":"SelectorIndice_active__3chzv"};